export default __webpack_public_path__ + "static/media/sunrise.2721fa53.svg";